import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IGeneratedDeliverable } from '@shared';
import { FirebaseService } from 'src/app/firebase/firebase.service';

@Component({
  selector: 'app-deliverable-result',
  templateUrl: './deliverable-result.component.html',
  styleUrls: ['./deliverable-result.component.scss']
})
export class DeliverableResultComponent implements OnInit {
  generatedDeliverable: IGeneratedDeliverable | null = null;
  masterclassId: string;
  loading: boolean = true;
  linkCopied: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit(): void {
    this.masterclassId = this.route.snapshot.paramMap.get('id');
    this.loadDeliverable();
  }

  loadDeliverable(): void {
    this.firebaseService.getELearningData().subscribe((data) => {
      const deliverables = data?.generatedDeliverables || [];
      const foundDeliverable = deliverables.find(d => d.masterclassId === this.masterclassId);

      if (foundDeliverable) {
        const rawDate = foundDeliverable.generatedAt as any;
        this.generatedDeliverable = {
          ...foundDeliverable,
          generatedAt: rawDate instanceof Date
            ? rawDate
            : rawDate?.toDate
              ? rawDate.toDate()
              : new Date(rawDate)
        };
      } else {
        this.generatedDeliverable = null;
      }

      this.loading = false;

      const isCompleted = this.generatedDeliverable &&
        (this.generatedDeliverable.status === 'completed' || !this.generatedDeliverable.status);

      if (!isCompleted) {
        this.router.navigate(['/e-learning/masterclasses', this.masterclassId, 'deliverable-recap']);
      }
    });
  }

  downloadPdf(): void {
    if (this.generatedDeliverable?.pdfUrl) {
      window.open(this.generatedDeliverable.pdfUrl, '_blank');
    }
  }

  copyGammaLink(): void {
    if (this.generatedDeliverable?.gammaUrl) {
      navigator.clipboard.writeText(this.generatedDeliverable.gammaUrl).then(() => {
        this.linkCopied = true;
        setTimeout(() => this.linkCopied = false, 3000);
      });
    }
  }

  goBack(): void {
    this.router.navigate(['/e-learning/masterclasses', this.masterclassId, 'modules']);
  }
}
